import { Injectable } from '@angular/core';
// import {PhoneNumberDetails} from "../shared/models/LoginInfoResponse";

/**
 * @return global native browser window
 */
const _window = (): any =>  window;

@Injectable({
  providedIn: 'root'
})

export class WindowRef {
  get nativeWindow(): Window {
    return WindowRef.nativeWindow;
  }

  static get nativeWindow(): Window {
    return _window();
  }

  static get document(): Document {
    return WindowRef.nativeWindow.document;
  }

  static scrollTo(x: number, y: number): void {
    WindowRef.nativeWindow.scrollTo(x, y);
  }
}
